__turbopack_context__.v({
  "cardAsset": "InfoCardsGrid-module__Hgethq__cardAsset",
  "cardImage": "InfoCardsGrid-module__Hgethq__cardImage",
  "cardSubtitle": "InfoCardsGrid-module__Hgethq__cardSubtitle",
  "cardText": "InfoCardsGrid-module__Hgethq__cardText",
  "cardTitle": "InfoCardsGrid-module__Hgethq__cardTitle",
  "container": "InfoCardsGrid-module__Hgethq__container",
  "darkCard": "InfoCardsGrid-module__Hgethq__darkCard",
  "grid": "InfoCardsGrid-module__Hgethq__grid",
  "h2White": "InfoCardsGrid-module__Hgethq__h2White",
  "root": "InfoCardsGrid-module__Hgethq__root" + " " + __turbopack_context__.i(46473)["sectionPadding"],
  "textContent": "InfoCardsGrid-module__Hgethq__textContent",
});
